module.exports = __webpack_public_path__ + "img/logo.3ddf48c.svg";